import React,{useContext} from "react";
import themeContext from "../../../context/theme/ThemeContext";
import { LIGHT_THEME_ICON_COLOR, THEME_NAME } from "../../../constants/Constants";
import { Icon } from "@fluentui/react";

const NavIcons = (props) => {
  const activeColor = "#2F80ED";
  const defaultColor = "#7B7B7B";

  const { theme, themeName, setThemeName, setTheme } = useContext(themeContext);

  switch (true) {
    case props.iconName == "clients":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M12.5025 9.8475C13.53 10.545 14.25 11.49 14.25 12.75V15H17.25V12.75C17.25 11.115 14.5725 10.1475 12.5025 9.8475Z" />
          <path d="M11.25 9C12.9075 9 14.25 7.6575 14.25 6C14.25 4.3425 12.9075 3 11.25 3C10.8975 3 10.5675 3.075 10.2525 3.18C10.875 3.9525 11.25 4.935 11.25 6C11.25 7.065 10.875 8.0475 10.2525 8.82C10.5675 8.925 10.8975 9 11.25 9Z" />
          <path d="M6.75 9C8.4075 9 9.75 7.6575 9.75 6C9.75 4.3425 8.4075 3 6.75 3C5.0925 3 3.75 4.3425 3.75 6C3.75 7.6575 5.0925 9 6.75 9ZM6.75 4.5C7.575 4.5 8.25 5.175 8.25 6C8.25 6.825 7.575 7.5 6.75 7.5C5.925 7.5 5.25 6.825 5.25 6C5.25 5.175 5.925 4.5 6.75 4.5Z" />
          <path d="M6.75 9.75C4.7475 9.75 0.75 10.755 0.75 12.75V15H12.75V12.75C12.75 10.755 8.7525 9.75 6.75 9.75ZM11.25 13.5H2.25V12.7575C2.4 12.2175 4.725 11.25 6.75 11.25C8.775 11.25 11.1 12.2175 11.25 12.75V13.5Z" />
        </svg>
      );
      break;
    case props.iconName == "providers":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M15 6.75V4.5H13.5V6.75H11.25V8.25H13.5V10.5H15V8.25H17.25V6.75H15ZM6.75 9C8.4075 9 9.75 7.6575 9.75 6C9.75 4.3425 8.4075 3 6.75 3C5.0925 3 3.75 4.3425 3.75 6C3.75 7.6575 5.0925 9 6.75 9ZM6.75 4.5C7.575 4.5 8.25 5.175 8.25 6C8.25 6.825 7.575 7.5 6.75 7.5C5.925 7.5 5.25 6.825 5.25 6C5.25 5.175 5.925 4.5 6.75 4.5ZM11.5425 10.92C10.2825 10.275 8.6475 9.75 6.75 9.75C4.8525 9.75 3.2175 10.275 1.9575 10.92C1.2075 11.3025 0.75 12.075 0.75 12.915V15H12.75V12.915C12.75 12.075 12.2925 11.3025 11.5425 10.92ZM11.25 13.5H2.25V12.915C2.25 12.63 2.4 12.375 2.64 12.255C3.5325 11.7975 4.9725 11.25 6.75 11.25C8.5275 11.25 9.9675 11.7975 10.86 12.255C11.1 12.375 11.25 12.63 11.25 12.915V13.5Z" />
        </svg>
      );
      break;

    case props.iconName == "firms":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M14.25 3H11.115C10.8 2.13 9.975 1.5 9 1.5C8.025 1.5 7.2 2.13 6.885 3H3.75C2.925 3 2.25 3.675 2.25 4.5V15C2.25 15.825 2.925 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM9 2.8125C9.165 2.8125 9.3075 2.8875 9.4125 3C9.5025 3.0975 9.5625 3.2325 9.5625 3.375C9.5625 3.6825 9.3075 3.9375 9 3.9375C8.6925 3.9375 8.4375 3.6825 8.4375 3.375C8.4375 3.2325 8.4975 3.0975 8.5875 3C8.6925 2.8875 8.835 2.8125 9 2.8125ZM14.25 15H3.75V4.5H14.25V15ZM9 5.25C7.7625 5.25 6.75 6.2625 6.75 7.5C6.75 8.7375 7.7625 9.75 9 9.75C10.2375 9.75 11.25 8.7375 11.25 7.5C11.25 6.2625 10.2375 5.25 9 5.25ZM9 8.25C8.5875 8.25 8.25 7.9125 8.25 7.5C8.25 7.0875 8.5875 6.75 9 6.75C9.4125 6.75 9.75 7.0875 9.75 7.5C9.75 7.9125 9.4125 8.25 9 8.25ZM4.5 13.1025V14.25H13.5V13.1025C13.5 11.2275 10.5225 10.4175 9 10.4175C7.4775 10.4175 4.5 11.22 4.5 13.1025ZM6.2325 12.75C6.75 12.33 8.0175 11.91 9 11.91C9.9825 11.91 11.2575 12.33 11.7675 12.75H6.2325Z" />
        </svg>
      );
      break;

    case props.iconName == "projects":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M3 7.5a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.5z"/>
        </svg>
      );
      break;  

    case props.iconName == "available-now":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M14.25 3H11.115C10.8 2.13 9.975 1.5 9 1.5C8.025 1.5 7.2 2.13 6.885 3H3.75C2.925 3 2.25 3.675 2.25 4.5V15C2.25 15.825 2.925 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM9 2.8125C9.165 2.8125 9.3075 2.8875 9.4125 3C9.5025 3.0975 9.5625 3.2325 9.5625 3.375C9.5625 3.6825 9.3075 3.9375 9 3.9375C8.6925 3.9375 8.4375 3.6825 8.4375 3.375C8.4375 3.2325 8.4975 3.0975 8.5875 3C8.6925 2.8875 8.835 2.8125 9 2.8125ZM14.25 15H3.75V4.5H14.25V15ZM9 5.25C7.7625 5.25 6.75 6.2625 6.75 7.5C6.75 8.7375 7.7625 9.75 9 9.75C10.2375 9.75 11.25 8.7375 11.25 7.5C11.25 6.2625 10.2375 5.25 9 5.25ZM9 8.25C8.5875 8.25 8.25 7.9125 8.25 7.5C8.25 7.0875 8.5875 6.75 9 6.75C9.4125 6.75 9.75 7.0875 9.75 7.5C9.75 7.9125 9.4125 8.25 9 8.25ZM4.5 13.1025V14.25H13.5V13.1025C13.5 11.2275 10.5225 10.4175 9 10.4175C7.4775 10.4175 4.5 11.22 4.5 13.1025ZM6.2325 12.75C6.75 12.33 8.0175 11.91 9 11.91C9.9825 11.91 11.2575 12.33 11.7675 12.75H6.2325Z"
            fill={
              themeName == THEME_NAME.LIGHT
                ? LIGHT_THEME_ICON_COLOR
                : "rgb(193, 193, 193"
            }
          />
        </svg>
      );
      break;

    case props.iconName == "account-settings":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.06348 13.125V12.6375C3.06348 12.3825 3.18348 12.1425 3.37098 12.03C4.63848 11.2725 6.08598 10.875 7.56348 10.875C7.58598 10.875 7.60098 10.875 7.62348 10.8825C7.69848 10.3575 7.84848 9.855 8.06598 9.3975C7.90098 9.3825 7.73598 9.375 7.56348 9.375C5.74848 9.375 4.05348 9.8775 2.60598 10.74C1.94598 11.13 1.56348 11.865 1.56348 12.6375V14.625H8.50848C8.19348 14.175 7.94598 13.665 7.78098 13.125H3.06348Z"
            fill={
              themeName == THEME_NAME.LIGHT
                ? LIGHT_THEME_ICON_COLOR
                : "rgb(193, 193, 193)"
            }
          />
          <path
            d="M7.56348 8.625C9.22098 8.625 10.5635 7.2825 10.5635 5.625C10.5635 3.9675 9.22098 2.625 7.56348 2.625C5.90598 2.625 4.56348 3.9675 4.56348 5.625C4.56348 7.2825 5.90598 8.625 7.56348 8.625ZM7.56348 4.125C8.38848 4.125 9.06348 4.8 9.06348 5.625C9.06348 6.45 8.38848 7.125 7.56348 7.125C6.73848 7.125 6.06348 6.45 6.06348 5.625C6.06348 4.8 6.73848 4.125 7.56348 4.125Z"
            fill={
              themeName == THEME_NAME.LIGHT
                ? LIGHT_THEME_ICON_COLOR
                : "rgb(193, 193, 193)"
            }
          />
          <path
            d="M15.626 11.625C15.626 11.46 15.6035 11.31 15.581 11.1525L16.436 10.395L15.686 9.0975L14.5985 9.465C14.3585 9.2625 14.0885 9.105 13.7885 8.9925L13.5635 7.875H12.0635L11.8385 8.9925C11.5385 9.105 11.2685 9.2625 11.0285 9.465L9.94098 9.0975L9.19098 10.395L10.046 11.1525C10.0235 11.31 10.001 11.46 10.001 11.625C10.001 11.79 10.0235 11.94 10.046 12.0975L9.19098 12.855L9.94098 14.1525L11.0285 13.785C11.2685 13.9875 11.5385 14.145 11.8385 14.2575L12.0635 15.375H13.5635L13.7885 14.2575C14.0885 14.145 14.3585 13.9875 14.5985 13.785L15.686 14.1525L16.436 12.855L15.581 12.0975C15.6035 11.94 15.626 11.79 15.626 11.625ZM12.8135 13.125C11.9885 13.125 11.3135 12.45 11.3135 11.625C11.3135 10.8 11.9885 10.125 12.8135 10.125C13.6385 10.125 14.3135 10.8 14.3135 11.625C14.3135 12.45 13.6385 13.125 12.8135 13.125Z"
            fill={
              themeName == THEME_NAME.LIGHT
                ? LIGHT_THEME_ICON_COLOR
                : "rgb(193, 193, 193)"
            }
          />
        </svg>
      );
      break;


    case props.iconName == "admin-user":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M3.06348 13.5V13.0125C3.06348 12.7575 3.18348 12.5175 3.37098 12.405C4.63848 11.6475 6.08598 11.25 7.56348 11.25C7.58598 11.25 7.60098 11.25 7.62348 11.2575C7.69848 10.7325 7.84848 10.23 8.06598 9.7725C7.90098 9.7575 7.73598 9.75 7.56348 9.75C5.74848 9.75 4.05348 10.2525 2.60598 11.115C1.94598 11.505 1.56348 12.24 1.56348 13.0125V15H8.50848C8.19348 14.55 7.94598 14.04 7.78098 13.5H3.06348Z" />
          <path d="M7.56348 9C9.22098 9 10.5635 7.6575 10.5635 6C10.5635 4.3425 9.22098 3 7.56348 3C5.90598 3 4.56348 4.3425 4.56348 6C4.56348 7.6575 5.90598 9 7.56348 9ZM7.56348 4.5C8.38848 4.5 9.06348 5.175 9.06348 6C9.06348 6.825 8.38848 7.5 7.56348 7.5C6.73848 7.5 6.06348 6.825 6.06348 6C6.06348 5.175 6.73848 4.5 7.56348 4.5Z" />
          <path
            d="M13.375 10.2333H13.1625V9.66667C13.1625 8.69762 12.4237 7.9 11.5 7.9C10.5763 7.9 9.8375 8.69762 9.8375 9.66667V10.2333H9.625C9.22004 10.2333 8.9 10.5843 8.9 11V14.3333C8.9 14.7491 9.22004 15.1 9.625 15.1H13.375C13.78 15.1 14.1 14.7491 14.1 14.3333V11C14.1 10.5843 13.78 10.2333 13.375 10.2333ZM10.6625 9.66667C10.6625 9.16238 11.0425 8.76667 11.5 8.76667C11.9575 8.76667 12.3375 9.16238 12.3375 9.66667V10.2333H10.6625V9.66667ZM9.725 14.2333V11.1H13.275V14.2333H9.725ZM11.5 13.4333C11.905 13.4333 12.225 13.0824 12.225 12.6667C12.225 12.2509 11.905 11.9 11.5 11.9C11.095 11.9 10.775 12.2509 10.775 12.6667C10.775 13.0824 11.095 13.4333 11.5 13.4333Z"
            strokeWidth="0.2"
          />
        </svg>
      );

    case props.iconName == "supervisor":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M9 4.5C9.825 4.5 10.5 5.175 10.5 6C10.5 6.825 9.825 7.5 9 7.5C8.175 7.5 7.5 6.825 7.5 6C7.5 5.175 8.175 4.5 9 4.5ZM9 11.25C11.025 11.25 13.35 12.2175 13.5 12.75V13.5H4.5V12.7575C4.65 12.2175 6.975 11.25 9 11.25ZM9 3C7.3425 3 6 4.3425 6 6C6 7.6575 7.3425 9 9 9C10.6575 9 12 7.6575 12 6C12 4.3425 10.6575 3 9 3ZM9 9.75C6.9975 9.75 3 10.755 3 12.75V15H15V12.75C15 10.755 11.0025 9.75 9 9.75Z" />
        </svg>
      );

    case props.iconName == "firm-technician":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M3.06348 13.125V12.6375C3.06348 12.3825 3.18348 12.1425 3.37098 12.03C4.63848 11.2725 6.08598 10.875 7.56348 10.875C7.58598 10.875 7.60098 10.875 7.62348 10.8825C7.69848 10.3575 7.84848 9.855 8.06598 9.3975C7.90098 9.3825 7.73598 9.375 7.56348 9.375C5.74848 9.375 4.05348 9.8775 2.60598 10.74C1.94598 11.13 1.56348 11.865 1.56348 12.6375V14.625H8.50848C8.19348 14.175 7.94598 13.665 7.78098 13.125H3.06348Z" />
          <path d="M7.56348 8.625C9.22098 8.625 10.5635 7.2825 10.5635 5.625C10.5635 3.9675 9.22098 2.625 7.56348 2.625C5.90598 2.625 4.56348 3.9675 4.56348 5.625C4.56348 7.2825 5.90598 8.625 7.56348 8.625ZM7.56348 4.125C8.38848 4.125 9.06348 4.8 9.06348 5.625C9.06348 6.45 8.38848 7.125 7.56348 7.125C6.73848 7.125 6.06348 6.45 6.06348 5.625C6.06348 4.8 6.73848 4.125 7.56348 4.125Z" />
          <path d="M15.626 11.625C15.626 11.46 15.6035 11.31 15.581 11.1525L16.436 10.395L15.686 9.0975L14.5985 9.465C14.3585 9.2625 14.0885 9.105 13.7885 8.9925L13.5635 7.875H12.0635L11.8385 8.9925C11.5385 9.105 11.2685 9.2625 11.0285 9.465L9.94098 9.0975L9.19098 10.395L10.046 11.1525C10.0235 11.31 10.001 11.46 10.001 11.625C10.001 11.79 10.0235 11.94 10.046 12.0975L9.19098 12.855L9.94098 14.1525L11.0285 13.785C11.2685 13.9875 11.5385 14.145 11.8385 14.2575L12.0635 15.375H13.5635L13.7885 14.2575C14.0885 14.145 14.3585 13.9875 14.5985 13.785L15.686 14.1525L16.436 12.855L15.581 12.0975C15.6035 11.94 15.626 11.79 15.626 11.625ZM12.8135 13.125C11.9885 13.125 11.3135 12.45 11.3135 11.625C11.3135 10.8 11.9885 10.125 12.8135 10.125C13.6385 10.125 14.3135 10.8 14.3135 11.625C14.3135 12.45 13.6385 13.125 12.8135 13.125Z" />
        </svg>
      );

    case props.iconName == "firm-doctor":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M3.06348 13.5V13.0125C3.06348 12.7575 3.18348 12.5175 3.37098 12.405C4.63848 11.6475 6.08598 11.25 7.56348 11.25C7.58598 11.25 7.60098 11.25 7.62348 11.2575C7.69848 10.7325 7.84848 10.23 8.06598 9.7725C7.90098 9.7575 7.73598 9.75 7.56348 9.75C5.74848 9.75 4.05348 10.2525 2.60598 11.115C1.94598 11.505 1.56348 12.24 1.56348 13.0125V15H8.50848C8.19348 14.55 7.94598 14.04 7.78098 13.5H3.06348Z" />
          <path d="M7.56348 9C9.22098 9 10.5635 7.6575 10.5635 6C10.5635 4.3425 9.22098 3 7.56348 3C5.90598 3 4.56348 4.3425 4.56348 6C4.56348 7.6575 5.90598 9 7.56348 9ZM7.56348 4.5C8.38848 4.5 9.06348 5.175 9.06348 6C9.06348 6.825 8.38848 7.5 7.56348 7.5C6.73848 7.5 6.06348 6.825 6.06348 6C6.06348 5.175 6.73848 4.5 7.56348 4.5Z" />
          <path
            d="M11.85 11.4V11.3H11.75H11.25H11.15V11.4V12.2H10.5H10.4V12.3V12.9V13H10.5H11.15V13.8V13.9H11.25H11.75H11.85V13.8V13H12.5H12.6V12.9V12.3V12.2H12.5H11.85V11.4ZM13.5 10.1H12.6V9.6C12.6 9.23262 12.3465 8.9 12 8.9H11C10.6535 8.9 10.4 9.23262 10.4 9.6V10.1H9.5C9.15347 10.1 8.9 10.4326 8.9 10.8V14.4C8.9 14.7674 9.15347 15.1 9.5 15.1H13.5C13.8465 15.1 14.1 14.7674 14.1 14.4V10.8C14.1 10.4326 13.8465 10.1 13.5 10.1ZM11.1 9.7H11.9V10.1H11.1V9.7ZM13.4 14.3H9.6V10.9H13.4V14.3Z"
            strokeWidth="0.2"
          />
        </svg>
      );
      break;

    case props.iconName == "tutorial-video":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M6.75 5.25V11.25L12 8.25L6.75 5.25ZM15.75 2.25H2.25C1.425 2.25 0.75 2.925 0.75 3.75V12.75C0.75 13.575 1.425 14.25 2.25 14.25H6V15.75H12V14.25H15.75C16.575 14.25 17.25 13.575 17.25 12.75V3.75C17.25 2.925 16.575 2.25 15.75 2.25ZM15.75 12.75H2.25V3.75H15.75V12.75Z" />
        </svg>
      );

    case props.iconName == "faq":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V16.5L4.5 13.5H15C15.825 13.5 16.5 12.825 16.5 12V3C16.5 2.175 15.825 1.5 15 1.5ZM15 12H4.5L3 13.5V3H15V12Z" />
          <path d="M5.72266 9H5.39062V6.14453H6.98047V6.4375H5.72266V7.48438H6.9043V7.77539H5.72266V9ZM9.24805 9L8.89648 8.09375H7.75195L7.40234 9H7.06641L8.18359 6.13281H8.48242L9.5918 9H9.24805ZM8.79688 7.79883L8.46289 6.89844C8.45508 6.875 8.44206 6.83659 8.42383 6.7832C8.4069 6.72982 8.38932 6.67448 8.37109 6.61719C8.35286 6.5599 8.33789 6.51367 8.32617 6.47852C8.31315 6.5319 8.29883 6.58529 8.2832 6.63867C8.26888 6.69076 8.25456 6.73958 8.24023 6.78516C8.22591 6.82943 8.21354 6.86719 8.20312 6.89844L7.86328 7.79883H8.79688ZM12.4648 7.56836C12.4648 7.80273 12.4329 8.01497 12.3691 8.20508C12.3053 8.39518 12.2103 8.55599 12.084 8.6875C11.959 8.81901 11.8027 8.91471 11.6152 8.97461L12.2871 9.67969H11.8125L11.2598 9.03516C11.2428 9.03516 11.2253 9.03581 11.207 9.03711C11.1901 9.03841 11.1732 9.03906 11.1562 9.03906C10.9349 9.03906 10.7415 9.00391 10.5762 8.93359C10.4121 8.86328 10.2754 8.76302 10.166 8.63281C10.0579 8.5026 9.97656 8.34701 9.92188 8.16602C9.86849 7.98503 9.8418 7.78451 9.8418 7.56445C9.8418 7.27279 9.88997 7.01693 9.98633 6.79688C10.0827 6.57682 10.2285 6.4056 10.4238 6.2832C10.6204 6.16081 10.8665 6.09961 11.1621 6.09961C11.4447 6.09961 11.6823 6.16016 11.875 6.28125C12.069 6.40234 12.2155 6.57292 12.3145 6.79297C12.4147 7.01172 12.4648 7.27018 12.4648 7.56836ZM10.1914 7.56836C10.1914 7.81055 10.2259 8.02018 10.2949 8.19727C10.3639 8.37435 10.4694 8.51107 10.6113 8.60742C10.7546 8.70378 10.9362 8.75195 11.1562 8.75195C11.3776 8.75195 11.5586 8.70378 11.6992 8.60742C11.8411 8.51107 11.946 8.37435 12.0137 8.19727C12.0814 8.02018 12.1152 7.81055 12.1152 7.56836C12.1152 7.19987 12.0378 6.91211 11.8828 6.70508C11.7292 6.49674 11.4889 6.39258 11.1621 6.39258C10.9408 6.39258 10.7585 6.4401 10.6152 6.53516C10.472 6.63021 10.3652 6.76562 10.2949 6.94141C10.2259 7.11589 10.1914 7.32487 10.1914 7.56836Z" />
        </svg>
      );

    case props.iconName == "support":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M8.25 6.75H9.75V8.25H8.25V6.75ZM11.25 6.75H12.75V8.25H11.25V6.75ZM15 11.625C14.0625 11.625 13.1625 11.475 12.3225 11.1975C12.2475 11.175 12.165 11.16 12.09 11.16C11.895 11.16 11.7075 11.235 11.5575 11.3775L9.9075 13.0275C7.785 11.9475 6.045 10.215 4.965 8.0925L6.615 6.435C6.825 6.2325 6.885 5.94 6.8025 5.6775C6.525 4.8375 6.375 3.9375 6.375 3C6.375 2.5875 6.0375 2.25 5.625 2.25H3C2.5875 2.25 2.25 2.5875 2.25 3C2.25 10.0425 7.9575 15.75 15 15.75C15.4125 15.75 15.75 15.4125 15.75 15V12.375C15.75 11.9625 15.4125 11.625 15 11.625ZM3.7725 3.75H4.8975C4.95 4.41 5.0625 5.0625 5.2425 5.6925L4.3425 6.6C4.035 5.6925 3.84 4.74 3.7725 3.75ZM14.25 14.2275C13.26 14.16 12.3 13.965 11.4 13.6575L12.3 12.7575C12.9375 12.9375 13.59 13.05 14.25 13.095V14.2275ZM14.25 6.75H15.75V8.25H14.25V6.75Z" />
        </svg>
      );
      break;

    case props.iconName == "theme":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill={
            themeName == THEME_NAME.LIGHT
              ? LIGHT_THEME_ICON_COLOR
              : "rgb(193, 193, 193"
          }
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.625 3.75V14.25H15.375V3.75H2.625ZM5.625 5.25V6.75H4.125V5.25H5.625ZM4.125 8.25V9.75H5.625V8.25H4.125ZM4.125 11.25H5.625V12.75H4.125V11.25ZM7.125 12.75H13.875V11.25H7.125V12.75ZM13.875 9.75H7.125V8.25H13.875V9.75ZM7.125 6.75H13.875V5.25H7.125V6.75Z"
            fill={
              themeName == THEME_NAME.LIGHT
                ? LIGHT_THEME_ICON_COLOR
                : "rgb(193, 193, 193"
            }
          />
        </svg>
      );
      break;

    case props.iconName == "tour":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18"
          viewBox="0 -960 960 960"
          width="18"
          fill={
            themeName == THEME_NAME.LIGHT
              ? LIGHT_THEME_ICON_COLOR
              : "rgb(193, 193, 193"
          }
        >
          <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-640v560h560v-560h-80v280l-100-60-100 60v-280H200Zm0 560v-560 560Z" />
        </svg>
      );
      break;

    case props.iconName === "billing":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18"
          viewBox="0 -960 960 960"
          width="18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M560-440q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM280-320q-33 0-56.5-23.5T200-400v-320q0-33 23.5-56.5T280-800h560q33 0 56.5 23.5T920-720v320q0 33-23.5 56.5T840-320H280Zm80-80h400q0-33 23.5-56.5T840-480v-160q-33 0-56.5-23.5T760-720H360q0 33-23.5 56.5T280-640v160q33 0 56.5 23.5T360-400Zm440 240H120q-33 0-56.5-23.5T40-240v-440h80v440h680v80ZM280-400v-320 320Z" />
        </svg>
      );
    case props.iconName === "ms-word":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="18"
          height="18"
          viewBox="0 0 50 50"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M 28.875 0 C 28.855469 0.0078125 28.832031 0.0195313 28.8125 0.03125 L 0.8125 5.34375 C 0.335938 5.433594 -0.0078125 5.855469 0 6.34375 L 0 43.65625 C -0.0078125 44.144531 0.335938 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 29.101563 50.023438 29.402344 49.949219 29.632813 49.761719 C 29.859375 49.574219 29.996094 49.296875 30 49 L 30 44 L 47 44 C 48.09375 44 49 43.09375 49 42 L 49 8 C 49 6.90625 48.09375 6 47 6 L 30 6 L 30 1 C 30.003906 0.710938 29.878906 0.4375 29.664063 0.246094 C 29.449219 0.0546875 29.160156 -0.0351563 28.875 0 Z M 28 2.1875 L 28 6.6875 C 27.941406 6.882813 27.941406 7.085938 28 7.28125 L 28 42.8125 C 27.972656 42.945313 27.972656 43.085938 28 43.21875 L 28 47.8125 L 2 42.84375 L 2 7.15625 Z M 30 8 L 47 8 L 47 42 L 30 42 L 30 37 L 44 37 L 44 35 L 30 35 L 30 29 L 44 29 L 44 27 L 30 27 L 30 22 L 44 22 L 44 20 L 30 20 L 30 15 L 44 15 L 44 13 L 30 13 Z M 4.625 15.65625 L 8.4375 34.34375 L 12.1875 34.34375 L 14.65625 22.375 C 14.769531 21.824219 14.875 21.101563 14.9375 20.25 L 14.96875 20.25 C 14.996094 21.023438 15.058594 21.75 15.1875 22.375 L 17.59375 34.34375 L 21.21875 34.34375 L 25.0625 15.65625 L 21.75 15.65625 L 19.75 28.125 C 19.632813 28.828125 19.558594 29.53125 19.53125 30.21875 L 19.5 30.21875 C 19.433594 29.339844 19.367188 28.679688 19.28125 28.21875 L 16.90625 15.65625 L 13.40625 15.65625 L 10.78125 28.0625 C 10.613281 28.855469 10.496094 29.582031 10.46875 30.25 L 10.40625 30.25 C 10.367188 29.355469 10.308594 28.625 10.21875 28.09375 L 8.1875 15.65625 Z"></path>
        </svg>
      );

    case props.iconName === "header-template":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18"
          viewBox="0 -960 960 960"
          width="18"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M240-560h360v-120H240v120Zm-40 440q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
        </svg>
      );

    case props.iconName === "my-styles":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 441 512.02"
          fill="none"
          className="active-nav-icon"
        >
          <path
            d="M324.87 279.77c32.01 0 61.01 13.01 82.03 34.02 21.09 21 34.1 50.05 34.1 82.1 0 32.06-13.01 61.11-34.02 82.11l-1.32 1.22c-20.92 20.29-49.41 32.8-80.79 32.8-32.06 0-61.1-13.01-82.1-34.02-21.01-21-34.02-50.05-34.02-82.11s13.01-61.1 34.02-82.1c21-21.01 50.04-34.02 82.1-34.02zM243.11 38.08v54.18c.99 12.93 5.5 23.09 13.42 29.85 8.2 7.01 20.46 10.94 36.69 11.23l37.92-.04-88.03-95.22zm91.21 120.49-41.3-.04c-22.49-.35-40.21-6.4-52.9-17.24-13.23-11.31-20.68-27.35-22.19-47.23l-.11-1.74V25.29H62.87c-10.34 0-19.75 4.23-26.55 11.03-6.8 6.8-11.03 16.21-11.03 26.55v336.49c0 10.3 4.25 19.71 11.06 26.52 6.8 6.8 16.22 11.05 26.52 11.05h119.41c2.54 8.79 5.87 17.25 9.92 25.29H62.87c-17.28 0-33.02-7.08-44.41-18.46C7.08 432.37 0 416.64 0 399.36V62.87c0-17.26 7.08-32.98 18.45-44.36C29.89 7.08 45.61 0 62.87 0h173.88c4.11 0 7.76 1.96 10.07 5l109.39 118.34c2.24 2.43 3.34 5.49 3.34 8.55l.03 119.72c-8.18-1.97-16.62-3.25-25.26-3.79v-89.25zm-229.76 54.49c-6.98 0-12.64-5.66-12.64-12.64 0-6.99 5.66-12.65 12.64-12.65h150.49c6.98 0 12.65 5.66 12.65 12.65 0 6.98-5.67 12.64-12.65 12.64H104.56zm0 72.3c-6.98 0-12.64-5.66-12.64-12.65 0-6.98 5.66-12.64 12.64-12.64h142.52c3.71 0 7.05 1.6 9.37 4.15a149.03 149.03 0 0 0-30.54 21.14H104.56zm0 72.3c-6.98 0-12.64-5.66-12.64-12.65 0-6.98 5.66-12.64 12.64-12.64h86.2c-3.82 8.05-6.95 16.51-9.29 25.29h-76.91zm255.53-21.34c-1.53-1.05-3.28-1.53-5.05-1.17-1.76.35-3.28 1.28-4.33 2.8l-6 8.47c-4.05-1.81-9.22-3-13.6-3.64l-1.89-11.04c-.36-1.87-1.3-3.27-2.7-4.35-1.53-1.04-3.17-1.4-5.04-1.04l-13.86 2.46c-1.76.35-3.18 1.18-4.35 2.7-1.04 1.52-1.52 3.18-1.17 5.05l1.77 10.1c-4.27 1.79-8.5 4.37-12.09 7.28l-9.41-6.47c-1.52-1.05-3.15-1.52-4.92-1.17-1.77.36-3.29 1.3-4.33 2.82l-7.99 11.39c-1.07 1.52-1.53 3.28-1.17 5.04.34 1.88 1.27 3.29 2.82 4.34l8.44 5.99c-1.78 4.02-3 9.26-3.63 13.61l-11.03 1.89c-1.89.36-3.29 1.29-4.36 2.7-1.06 1.53-1.4 3.16-1.06 5.04l2.47 13.85c.35 1.77 1.18 3.17 2.7 4.35 1.53 1.06 3.18 1.53 5.06 1.18l10.09-1.77c1.86 4.42 4.4 8.4 7.28 12.22l-6.47 9.26c-1.05 1.53-1.52 3.18-1.16 4.93.35 1.76 1.3 3.29 2.82 4.33l11.49 8.11c1.53 1.06 3.3 1.41 5.04 1.06 1.77-.35 3.3-1.17 4.48-2.69l5.97-8.58c4.12 1.82 9.17 2.97 13.63 3.65l1.88 11.03c.34 1.89 1.28 3.29 2.69 4.35 1.54 1.05 3.18 1.4 5.06 1.05l13.84-2.47c1.77-.35 3.17-1.17 4.35-2.69 1.05-1.53 1.51-3.17 1.16-5.04l-1.75-10.1c4.47-1.88 8.35-4.41 12.2-7.29l9.29 6.46c1.53 1.05 3.16 1.52 5.04 1.16 1.88-.33 3.29-1.27 4.33-2.81l8.11-11.51c1.05-1.52 1.42-3.29 1.05-5.03-.34-1.76-1.16-3.29-2.68-4.48l-8.58-5.86c1.78-4.02 3-9.25 3.63-13.6l11.04-1.89c1.88-.36 3.28-1.3 4.36-2.7 1.05-1.52 1.4-3.17 1.05-5.04l-2.47-13.86c-.35-1.77-1.17-3.17-2.69-4.34-1.53-1.07-3.19-1.54-5.06-1.18l-10.1 1.77c-1.94-4.4-4.27-8.35-7.28-12.09l6.47-9.4c1.05-1.53 1.52-3.17 1.16-4.93-.35-1.76-1.3-3.29-2.82-4.35l-11.38-7.97-.35.11zm-35.2 29.98c16.34 0 29.6 13.25 29.6 29.6 0 16.34-13.26 29.59-29.6 29.59-16.34 0-29.6-13.25-29.6-29.59 0-16.35 13.26-29.6 29.6-29.6z"
          />
        </svg>
      );

    case props.iconName === "ai-file":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 400 400"
            className="active-nav-icon"
          >
            <path d="M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z" />
            <path d="M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z" />
            <path d="M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z" />
            <path d="M275,280H125a5,5,0,1,1,0-10H275a5,5,0,0,1,0,10Z" />
            <path d="M200,330H125a5,5,0,1,1,0-10h75a5,5,0,0,1,0,10Z" />
            <path d="M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z" />
            <path d="M212.91,236H202.64l-4.26-12.7H177.87L173.69,236h-8.2l17.7-53.32H195ZM195.8,215.61,188,191.82l-7.77,23.79Z" />
            <path d="M228.93,236h-9.61V182.68h9.61Z" />
          </svg>
        );

            case props.iconName === "external-firm-connection":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 512 512"
            className="active-nav-icon"
          >
            <path
              d="M181.333333,0
              C234.352669,0 277.333333,42.980664 277.333333,96
              C277.333333,147.504498 236.773621,189.535767 185.852495,191.89551
              L181.333333,192
              L117.333333,192
              C87.8781467,192 64,215.878147 64,245.333333
              C64,273.610313 86.0061,296.747492 113.826652,298.553223
              L117.333333,298.666667
              L194.68864,298.665629
              C204.04963,262.29754 236.783165,235.312679 275.922191,234.678099
              L277.333333,234.666667
              L341.333333,234.666667
              L341.333,266.666667
              L405.333333,266.666667
              L405.333333,298.666667
              L341.333,298.666667
              L341.333,341.332667
              L405.333333,341.333333
              L405.333333,373.333333
              L341.333,373.332667
              L341.333333,405.333333
              L277.333333,405.333333
              C237.571799,405.333333 204.161914,378.138692 194.68864,341.334371
              L117.333333,341.333333
              C64.3139973,341.333333 21.3333333,298.352669 21.3333333,245.333333
              C21.3333333,193.828836 61.8930457,151.797566 112.814172,149.437824
              L117.333333,149.333333
              L181.333333,149.333333
              C210.78852,149.333333 234.666667,125.455187 234.666667,96
              C234.666667,67.7230208 212.660567,44.5858417 184.840015,42.7801105
              L181.333333,42.6666667
              L0,42.6666667
              L0,0
              Z"
            />
          </svg>
        );  

      case props.iconName === "report-template":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="18"
            viewBox="0 -960 960 960"
            width="18"
            fill="none"
            className="active-nav-icon"
          >
            <path 
            d="M320-480v-80h320v80H320Zm0-160v-80h320v80H320Zm-80 240h300q29 0 54 12.5t42 35.5l84 110v-558H240v400Zm0 240h442L573-303q-6-8-14.5-12.5T540-320H240v160Zm480 80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80Zm-480-80v-640 640Zm0-160v-80 80Z" />
          </svg>
        );

      case props.iconName === "troubleshooting":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            className="active-nav-icon"
          >
            <path d="M7 0H2.8C2.0268 0 1.4 0.626802 1.4 1.4V7.00001H1.8211L2.72712 4.93319C3.135 4.00272 4.39968 3.96147 4.89732 4.79023L4.91738 4.82364L4.97703 4.94656L6.18631 7.96645L6.42848 7.61001C6.61457 7.28928 6.93491 7.07197 7.29721 7.01488L7.33449 7.00901L7.4634 6.99995H8.88791C9.56446 6.99995 10.1129 7.54841 10.1129 8.22495C10.1129 8.83906 9.66157 9.34694 9.07174 9.43615L9.03582 9.44158L8.91143 9.44995H8.18317L7.018 11.2718C6.5537 12.1036 5.37217 12.0958 4.89941 11.3024L4.8799 11.2697L4.82183 11.1496L3.79797 8.59275L3.74358 8.71683C3.58594 9.07645 3.26873 9.33306 2.89664 9.41876C2.87183 9.42448 2.84671 9.42945 2.82139 9.43363L2.78243 9.44007L2.64736 9.45001L1.4 9.45001V12.6C1.4 13.3732 2.0268 14 2.8 14H11.2C11.9732 14 12.6 13.3732 12.6 12.6V5.6H8.4C7.62772 5.6 7.00149 4.97469 7 4.20276L7 0Z" />
            <path d="M8.4 4.55C8.2067 4.55 8.05 4.3933 8.05 4.2V0.35L12.25 4.55H8.4Z" />
            <path d="M2.27855 7.70001L0.525003 7.7L0.453024 7.70485L0.445843 7.70593C0.193331 7.74413 0 7.96208 0 8.22501C0 8.51496 0.23505 8.75 0.525 8.75L2.62164 8.75001L2.69952 8.74428L2.70731 8.74299C2.71814 8.7412 2.72888 8.73907 2.73952 8.73662C2.89903 8.69988 3.03495 8.58983 3.10247 8.43579L3.82716 6.78261L5.46262 10.8668L5.49683 10.9375L5.50073 10.9441C5.70493 11.2868 6.22225 11.284 6.41488 10.9156L7.79994 8.74995H8.88791L8.95988 8.74511L8.96706 8.74402C9.21958 8.70583 9.41291 8.48788 9.41291 8.22495C9.41291 7.935 9.17786 7.69995 8.88791 7.69995H7.48796L7.41361 7.70517L7.40616 7.70635C7.24454 7.73181 7.10237 7.83177 7.02438 7.97854L6.0257 9.4484L4.33643 5.22984L4.30121 5.15726L4.2972 5.15058C4.08485 4.79694 3.54231 4.8171 3.36822 5.21423L2.27855 7.70001Z" />
          </svg>
        );

    case props.iconName === "analytics":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M5.80488 1.70732C6.08776 1.70732 6.31707 1.93663 6.31707 2.21951V7.68293H11.7805C12.0398 7.68293 12.2541 7.87562 12.288 8.12562L12.2927 8.19512C12.2927 11.5897 9.54087 14 6.14634 14C2.75181 14 0 11.2482 0 7.85366C0 4.45913 2.41035 1.70732 5.80488 1.70732ZM7.85366 0C11.2482 0 14 2.75181 14 6.14634C14 6.42922 13.7707 6.65854 13.4878 6.65854H7.85366C7.57078 6.65854 7.34146 6.42922 7.34146 6.14634V0.512195C7.34146 0.229318 7.57078 0 7.85366 0Z" />
        </svg>
      );

    case props.iconName === "studylist":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          className="active-nav-icon"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.625 3.75V14.25H15.375V3.75H2.625ZM5.625 5.25V6.75H4.125V5.25H5.625ZM4.125 8.25V9.75H5.625V8.25H4.125ZM4.125 11.25H5.625V12.75H4.125V11.25ZM7.125 12.75H13.875V11.25H7.125V12.75ZM13.875 9.75H7.125V8.25H13.875V9.75ZM7.125 6.75H13.875V5.25H7.125V6.75Z"
          />
        </svg>
      );

    case props.iconName === "modality":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 58 58"
          fill="none"
          //className="active-nav-icon"
          className="active-nav-icon modality-icon"
        >
          <circle cx="29" cy="29" r="28" stroke="black" strokeWidth="2" />
          <circle cx="29.3031" cy="28.7484" r="4.64098" fill={themeName!="light"?"black":"white"} />
          <path
            d="M15.3331 10.1725C14.9744 9.75248 15.0228 9.11933 15.4583 8.77966C19.5783 5.56619 24.6983 3.87928 29.9419 4.0281C35.1856 4.17693 40.2016 6.15153 44.1327 9.59351C44.5482 9.95733 44.5607 10.5922 44.1788 10.9912L32.5712 23.1173C32.1894 23.5162 31.5597 23.5152 31.0738 23.2528C30.5653 22.9782 29.9957 22.8234 29.409 22.8068C28.8222 22.7901 28.2448 22.9123 27.7215 23.1576C27.2215 23.3921 26.5928 23.3574 26.2341 22.9374L15.3331 10.1725Z"
            fill={themeName!="light"?"black":"white"}
          />
          <path
            d="M51.8008 24.2661C52.3322 24.1154 52.8873 24.4237 53.0142 24.9612C54.2147 30.0465 53.6105 35.4032 51.2866 40.1061C48.9626 44.809 45.0745 48.543 40.3059 50.6786C39.8018 50.9043 39.2197 50.6506 39.0166 50.137L32.8423 34.5276C32.6392 34.014 32.9029 33.4423 33.3443 33.1102C33.806 32.7627 34.1844 32.3098 34.4445 31.7835C34.7045 31.2573 34.8344 30.6815 34.8299 30.1037C34.8256 29.5514 35.1196 28.9946 35.6509 28.844L51.8008 24.2661Z"
            fill={themeName!="light"?"black":"white"}
          />
          <path
            d="M20.9731 50.4397C20.8126 50.9681 20.2532 51.2685 19.7324 51.0847C14.8052 49.3458 10.6251 45.9419 7.92474 41.4446C5.22438 36.9472 4.18467 31.6578 4.96571 26.4914C5.04827 25.9454 5.57638 25.5928 6.11826 25.6995L22.5882 28.9428C23.13 29.0495 23.4685 29.5805 23.5093 30.1313C23.552 30.7076 23.7285 31.2708 24.0307 31.774C24.3329 32.2773 24.747 32.6978 25.2356 33.0064C25.7026 33.3013 26.0121 33.8496 25.8516 34.378L20.9731 50.4397Z"
            fill={themeName!="light"?"black":"white"}
          />
        </svg>
      );

      case props.iconName === "sub-modality":
      return (
       <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 58 58"
    fill="none"
    className="active-nav-icon"
  >
    <circle cx="29" cy="29" r="28" stroke="black" strokeWidth="2" />
    <path
      d="M29 4 L35 20 H45 L37 30 L40 46 L29 37 L18 46 L21 30 L13 20 H23 L29 4"
      fill={themeName!="light"?"black":"white"}
    />
    <path
      d="M29 12 L34 25 H24 L29 12 M29 46 L34 33 H24 L29 46"
      fill={themeName!="light"?"black":"white"}
    />
    <circle cx="29" cy="29" r="6" fill={themeName!="light"?"black":"white"} />
  </svg>

      );

    case props.iconName === "finding":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          className="active-nav-icon"
        >
          <path d="M10.5001 6.3C12.6264 6.3 14.3501 8.0237 14.3501 10.15C14.3501 12.2763 12.6264 14 10.5001 14C8.37377 14 6.65007 12.2763 6.65007 10.15C6.65007 8.0237 8.37377 6.3 10.5001 6.3ZM10.6751 0C11.8882 0 12.8795 0.949518 12.9465 2.1459L12.9501 2.275L12.9506 6.31558C12.2432 5.86262 11.4023 5.6 10.5001 5.6C9.2086 5.6 8.04281 6.13806 7.21463 7.00224L4.3735 7.00214L4.30226 7.00693C4.04601 7.04169 3.8485 7.26135 3.8485 7.52714C3.8485 7.79292 4.04601 8.01258 4.30226 8.04734L4.3735 8.05214L6.46156 8.05204C6.13478 8.6798 5.95007 9.39333 5.95007 10.15C5.95007 11.0524 6.21278 11.8935 6.66589 12.6008L2.62507 12.6C1.41195 12.6 0.420599 11.6505 0.353672 10.4541L0.350071 10.325L0.34987 4.46045C0.514136 4.51854 0.690913 4.55014 0.875071 4.55014C1.74496 4.55014 2.45014 3.84496 2.45014 2.97507C2.45014 2.10518 1.74496 1.4 0.875071 1.4C0.748212 1.4 0.624857 1.415 0.50668 1.44332C0.823099 0.638507 1.58484 0.0575374 2.4885 0.00403197L2.62507 0H10.6751ZM11.2001 11.9011H9.80007L9.80478 11.9827C9.84521 12.3308 10.1411 12.6011 10.5001 12.6011C10.8867 12.6011 11.2001 12.2877 11.2001 11.9011ZM10.5024 7.7L10.3853 7.70497C9.72954 7.76468 9.21673 8.23999 9.11906 8.8492L9.10619 8.95804L9.10225 9.10064V10.0055L8.50292 10.6032C8.2967 10.8089 8.41889 11.1514 8.68981 11.1962L8.75007 11.2011H12.2501C12.5411 11.2011 12.6965 10.8726 12.5367 10.6496L12.4976 10.6036L11.9035 10.0095V9.06284L11.8997 8.96052C11.846 8.25148 11.2392 7.7 10.5024 7.7ZM8.92664 4.54736H4.3735L4.30226 4.55215C4.04601 4.58692 3.8485 4.80657 3.8485 5.07236C3.8485 5.33815 4.04601 5.5578 4.30226 5.59257L4.3735 5.59736H8.92664L8.99788 5.59257C9.25413 5.5578 9.45164 5.33815 9.45164 5.07236C9.45164 4.78241 9.21659 4.54736 8.92664 4.54736ZM0.875071 2.1C1.35836 2.1 1.75014 2.49178 1.75014 2.97507C1.75014 3.45836 1.35836 3.85014 0.875071 3.85014C0.391783 3.85014 0 3.45836 0 2.97507C0 2.49178 0.391783 2.1 0.875071 2.1Z" />
        </svg>
      );

    case props.iconName === "added":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
        >
          <path
            d="M7.15 7.8H8.45V5.85H10.4V4.55H8.45V2.6H7.15V4.55H5.2V5.85H7.15V7.8ZM3.9 10.4C3.5425 10.4 3.23646 10.2727 2.98187 10.0181C2.72729 9.76354 2.6 9.4575 2.6 9.1V1.3C2.6 0.9425 2.72729 0.636458 2.98187 0.381875C3.23646 0.127292 3.5425 0 3.9 0H11.7C12.0575 0 12.3635 0.127292 12.6181 0.381875C12.8727 0.636458 13 0.9425 13 1.3V9.1C13 9.4575 12.8727 9.76354 12.6181 10.0181C12.3635 10.2727 12.0575 10.4 11.7 10.4H3.9ZM1.3 13C0.9425 13 0.636458 12.8727 0.381875 12.6181C0.127292 12.3635 0 12.0575 0 11.7V2.6H1.3V11.7H10.4V13H1.3Z"
            fill="#09CB1C"
          />
        </svg>
      );

    case props.iconName === "verified":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <path
            d="M5.18182 14L3.88636 11.8667L1.43182 11.3333L1.67045 8.86667L0 7L1.67045 5.13333L1.43182 2.66667L3.88636 2.13333L5.18182 0L7.5 0.966667L9.81818 0L11.1136 2.13333L13.5682 2.66667L13.3295 5.13333L15 7L13.3295 8.86667L13.5682 11.3333L11.1136 11.8667L9.81818 14L7.5 13.0333L5.18182 14ZM6.78409 9.36667L10.6364 5.6L9.68182 4.63333L6.78409 7.46667L5.31818 6.06667L4.36364 7L6.78409 9.36667Z"
            fill="#2F80ED"
          />
        </svg>
      );

    case props.iconName === "rejected":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
        >
          <path
            d="M3.75 8.25H11.25V6.75H3.75V8.25ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4813 2.19375 12.8063C1.51875 12.1313 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1313 1.51875 12.8063 2.19375C13.4813 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4813 12.1313 12.8063 12.8063C12.1313 13.4813 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15Z"
            fill="#F58220"
          />
        </svg>
      );

    case props.iconName === "more":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 -960 960 960"
          className="active-nav-icon"
        >
          <path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z" 
          />
        </svg>
      );

    case props.iconName === "preview":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="10"
          viewBox="0 0 14 9"
          fill="none"
          className="study-list-report-icons"
        >
          <path d="M7 1.2C9.41182 1.2 11.5627 2.478 12.6127 4.5C11.5627 6.522 9.41182 7.8 7 7.8C4.58818 7.8 2.43727 6.522 1.38727 4.5C2.43727 2.478 4.58818 1.2 7 1.2ZM7 0C3.81818 0 1.10091 1.866 0 4.5C1.10091 7.134 3.81818 9 7 9C10.1818 9 12.8991 7.134 14 4.5C12.8991 1.866 10.1818 0 7 0ZM7 3C7.87818 3 8.59091 3.672 8.59091 4.5C8.59091 5.328 7.87818 6 7 6C6.12182 6 5.40909 5.328 5.40909 4.5C5.40909 3.672 6.12182 3 7 3ZM7 1.8C5.42182 1.8 4.13636 3.012 4.13636 4.5C4.13636 5.988 5.42182 7.2 7 7.2C8.57818 7.2 9.86364 5.988 9.86364 4.5C9.86364 3.012 8.57818 1.8 7 1.8Z" />
        </svg>
      );

    case props.iconName === "pacs-queue":
      return (
        <svg 
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="10"
          viewBox="0 0 412 312"
          fill="none"
          className="active-nav-icon">
            <path d="M139.6 35.5a12 12 0 0 0 -17 0L58.9 98.8l-22.7-22.1a12 12 0 0 0 -17 0L3.5 92.4a12 12 0 0 0 0 17l47.6 47.4a12.8 12.8 0 0 0 17.6 0l15.6-15.6L156.5 69a12.1 12.1 0 0 0 .1-17zm0 159.2a12 12 0 0 0 -17 0l-63.7 63.7-22.7-22.1a12 12 0 0 0 -17 0L3.5 252a12 12 0 0 0 0 17L51 316.5a12.8 12.8 0 0 0 17.6 0l15.7-15.7 72.2-72.2a12 12 0 0 0 .1-16.9zM64 368c-26.5 0-48.6 21.5-48.6 48S37.5 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0 -16-16zm0-320H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0 -16-16zm0 160H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0 -16-16z"/>
        </svg>
      );

    case props.iconName === "ai-requests":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="17"
          viewBox="0 0 512 512"
          fill="currentColor"
          className="active-nav-icon"
        >
          <path d="M256 32a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm160 96a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0-96a32 32 0 1 1-32 32 32 32 0 0 1 32-32zM96 224a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0-96a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm256 128H160a16 16 0 0 0 0 32h192a16 16 0 0 0 0-32zm-96 64a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm0 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32z" />
        </svg>
      );

    case props.iconName === "firm2firm":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="17"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="active-nav-icon"
        >
          <path d="M3 21h6v-2H5v-4H3v6zm0-8h2V9h4V7H3v6zm8 8h6v-2h-4v-4h-2v6zm0-8h2V9h4V7h-6v6zm5-6V3h2v4h4v2h-6zm-8 0V3h6v2h-4v4H8z" />
          <path d="M14 11l3-3 3 3-1.4 1.4-1.6-1.6V16h-2v-6.2l-1.6 1.6L14 11z" opacity="0.85" />
        </svg>
      );
      case props.iconName == "hanging-protocol":
        return (
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" className="active-nav-icon" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.96538 11.2C7.96538 11.1602 7.97997 11.1221 8.00594 11.0939C8.03191 11.0658 8.06712 11.05 8.10385 11.05C8.14057 11.05 8.17579 11.0658 8.20175 11.0939C8.22772 11.1221 8.24231 11.1602 8.24231 11.2C8.24231 11.2398 8.22772 11.2779 8.20175 11.3061C8.17579 11.3342 8.14057 11.35 8.10385 11.35C8.06712 11.35 8.03191 11.3342 8.00594 11.3061C7.97997 11.2779 7.96538 11.2398 7.96538 11.2ZM6.99615 11.05C6.95943 11.05 6.92421 11.0658 6.89825 11.0939C6.87228 11.1221 6.85769 11.1602 6.85769 11.2C6.85769 11.2398 6.87228 11.2779 6.89825 11.3061C6.92421 11.3342 6.95943 11.35 6.99615 11.35C7.03288 11.35 7.06809 11.3342 7.09406 11.3061C7.12003 11.2779 7.13462 11.2398 7.13462 11.2C7.13462 11.1602 7.12003 11.1221 7.09406 11.0939C7.06809 11.0658 7.03288 11.05 6.99615 11.05ZM5.75 8.5C5.75 8.30109 5.82294 8.11032 5.95277 7.96967C6.08261 7.82902 6.2587 7.75 6.44231 7.75H8.65769C8.8413 7.75 9.01739 7.82902 9.14723 7.96967C9.27706 8.11032 9.35 8.30109 9.35 8.5V11.8C9.35 11.9989 9.27706 12.1897 9.14723 12.3303C9.01739 12.471 8.8413 12.55 8.65769 12.55H6.44231C6.2587 12.55 6.08261 12.471 5.95277 12.3303C5.82294 12.1897 5.75 11.9989 5.75 11.8V8.5ZM7.68846 8.8C7.68846 8.76022 7.67387 8.72206 7.64791 8.69393C7.62194 8.6658 7.58672 8.65 7.55 8.65C7.51328 8.65 7.47806 8.6658 7.45209 8.69393C7.42613 8.72206 7.41154 8.76022 7.41154 8.8V8.95H6.99615C6.95943 8.95 6.92421 8.9658 6.89825 8.99393C6.87228 9.02206 6.85769 9.06022 6.85769 9.1C6.85769 9.13978 6.87228 9.17794 6.89825 9.20607C6.92421 9.2342 6.95943 9.25 6.99615 9.25H7.41154V9.55H6.71923C6.68251 9.55 6.64729 9.5658 6.62132 9.59393C6.59536 9.62206 6.58077 9.66022 6.58077 9.7C6.58077 9.73978 6.59536 9.77794 6.62132 9.80607C6.64729 9.8342 6.68251 9.85 6.71923 9.85H7.41154V10.15H6.71923C6.68251 10.15 6.64729 10.1658 6.62132 10.1939C6.59536 10.2221 6.58077 10.2602 6.58077 10.3C6.58077 10.3398 6.59536 10.3779 6.62132 10.4061C6.64729 10.4342 6.68251 10.45 6.71923 10.45H7.41154V10.75H6.99615C6.90799 10.7501 6.82212 10.7805 6.75098 10.8369C6.67985 10.8933 6.62713 10.9728 6.60045 11.0639C6.57378 11.1549 6.57454 11.2528 6.60261 11.3433C6.63069 11.4339 6.68464 11.5124 6.75664 11.5675C6.82864 11.6226 6.91496 11.6515 7.00312 11.6499C7.09127 11.6484 7.17669 11.6165 7.247 11.5589C7.31731 11.5012 7.36887 11.4209 7.39422 11.3294C7.41957 11.2379 7.41739 11.1401 7.388 11.05H7.712C7.68261 11.1401 7.68043 11.2379 7.70578 11.3294C7.73113 11.4209 7.78269 11.5012 7.853 11.5589C7.92331 11.6165 8.00873 11.6484 8.09688 11.6499C8.18504 11.6515 8.27136 11.6226 8.34336 11.5675C8.41536 11.5124 8.46931 11.4339 8.49738 11.3433C8.52546 11.2528 8.52622 11.1549 8.49955 11.0639C8.47287 10.9728 8.42015 10.8933 8.34902 10.8369C8.27788 10.7805 8.19201 10.7501 8.10385 10.75H7.68846V10.45H8.38077C8.41749 10.45 8.45271 10.4342 8.47868 10.4061C8.50464 10.3779 8.51923 10.3398 8.51923 10.3C8.51923 10.2602 8.50464 10.2221 8.47868 10.1939C8.45271 10.1658 8.41749 10.15 8.38077 10.15H7.68846V9.85H8.38077C8.41749 9.85 8.45271 9.8342 8.47868 9.80607C8.50464 9.77794 8.51923 9.73978 8.51923 9.7C8.51923 9.66022 8.50464 9.62206 8.47868 9.59393C8.45271 9.5658 8.41749 9.55 8.38077 9.55H7.68846V9.25H8.10385C8.14057 9.25 8.17579 9.2342 8.20175 9.20607C8.22772 9.17794 8.24231 9.13978 8.24231 9.1C8.24231 9.06022 8.22772 9.02206 8.20175 8.99393C8.17579 8.9658 8.14057 8.95 8.10385 8.95H7.68846V8.8Z"/>
            <path d="M13.125 1.5H10.875V0.375C10.875 0.275544 10.8355 0.180161 10.7652 0.109835C10.6948 0.0395089 10.5995 0 10.5 0C10.4005 0 10.3052 0.0395089 10.2348 0.109835C10.1645 0.180161 10.125 0.275544 10.125 0.375V1.5H4.875V0.375C4.875 0.275544 4.83549 0.180161 4.76517 0.109835C4.69484 0.0395089 4.59946 0 4.5 0C4.40054 0 4.30516 0.0395089 4.23484 0.109835C4.16451 0.180161 4.125 0.275544 4.125 0.375V1.5H1.875C1.3779 1.5006 0.901334 1.69833 0.549832 2.04983C0.198331 2.40133 0.000595447 2.8779 0 3.375V13.125C0.000595447 13.6221 0.198331 14.0987 0.549832 14.4502C0.901334 14.8017 1.3779 14.9994 1.875 15H13.125C13.6223 15 14.0992 14.8025 14.4508 14.4508C14.8025 14.0992 15 13.6223 15 13.125V3.375C15 2.87772 14.8025 2.40081 14.4508 2.04917C14.0992 1.69754 13.6223 1.5 13.125 1.5ZM14.25 13.125C14.25 13.4234 14.1315 13.7095 13.9205 13.9205C13.7095 14.1315 13.4234 14.25 13.125 14.25H1.875C1.57663 14.25 1.29048 14.1315 1.0795 13.9205C0.868526 13.7095 0.75 13.4234 0.75 13.125V6.75H14.25V13.125ZM14.25 6H0.75V3.375C0.75 2.754 1.2525 2.25 1.875 2.25H4.125V3.375C4.125 3.47446 4.16451 3.56984 4.23484 3.64016C4.30516 3.71049 4.40054 3.75 4.5 3.75C4.59946 3.75 4.69484 3.71049 4.76517 3.64016C4.83549 3.56984 4.875 3.47446 4.875 3.375V2.25H10.125V3.375C10.125 3.47446 10.1645 3.56984 10.2348 3.64016C10.3052 3.71049 10.4005 3.75 10.5 3.75C10.5995 3.75 10.6948 3.71049 10.7652 3.64016C10.8355 3.56984 10.875 3.47446 10.875 3.375V2.25H13.125C13.4234 2.25 13.7095 2.36853 13.9205 2.5795C14.1315 2.79048 14.25 3.07663 14.25 3.375V6Z" />
          </svg>

        );
      case props.iconName === "adv-license":
        return (
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="10"
            viewBox="60 80 412 412"
            fill="none"
            className="active-nav-icon">
              <path d="M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"/>
          </svg>
        );
      case props.iconName === "logout-all":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            className="active-nav-icon"
          >
            <path
              d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
              stroke={themeName === THEME_NAME.LIGHT ? LIGHT_THEME_ICON_COLOR : "rgb(193, 193, 193)"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 17L21 12L16 7"
              stroke={themeName === THEME_NAME.LIGHT ? LIGHT_THEME_ICON_COLOR : "rgb(193, 193, 193)"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 12H9"
              stroke={themeName === THEME_NAME.LIGHT ? LIGHT_THEME_ICON_COLOR : "rgb(193, 193, 193)"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      case props.iconName === "gateway-dashboard":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="17"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="active-nav-icon"
          >
            <path d="M12 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            <path d="M5 15a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm14-2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            <path d="M11 8h2v5h-2zM5.5 13.5l1.4 1.4 3.5-3.5-1.4-1.4zM17.1 10l-1.4 1.4 3.5 3.5 1.4-1.4z" />
          </svg>
        );


    default:
      return <></>;
  }
};

export default NavIcons;
